import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MeheService } from '../_services/mehe-service/mehe.service';
import { MeheIngestionStats } from '../_models/mehe-ingestion-stats';
import { DateUtils } from '../_commons/date-utils';

const REFRESH_INTERVAL_MS = 30000;
const SNACKBAR_DURATION_MS = 1400;

@Component({
  selector: 'app-mehe-stats-dialog',
  templateUrl: './mehe-stats-dialog.component.html',
  styleUrls: ['./mehe-stats-dialog.component.css']
})
export class MeheStatsDialogComponent implements OnInit, OnDestroy {
  meheStats: MeheIngestionStats[] = [];
  loading = true;
  loadError = false;
  private refreshHandle: any;

  constructor(
    public activeModal: NgbActiveModal,
    private meheService: MeheService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loadStats(false);
    this.refreshHandle = setInterval(() => this.loadStats(false), REFRESH_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshHandle);
  }

  manualRefresh(): void {
    this.loadStats(true);
  }

  loadStats(notify: boolean): void {
    this.meheService.getMeheIngestionStats().subscribe(
      (stats) => {
        this.meheStats = stats;
        this.loading = false;
        this.loadError = false;
        if (notify) {
          this.showSnackbar('mehestatsdialog.refreshSuccess', 'snackbar-success');
        }
      },
      () => {
        this.loading = false;
        this.loadError = true;
        if (notify) {
          this.showSnackbar('mehestatsdialog.refreshError', 'snackbar-error');
        }
      }
    );
  }

  private showSnackbar(translationKey: string, panelClass: string): void {
    this.snackBar.open(this.translateService.instant(translationKey), '', {
      duration: SNACKBAR_DURATION_MS,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

  formatLocalTimestamp(utcTimestamp: string): string {
    if (!utcTimestamp) {
      return '-';
    }
    return DateUtils.stringUTCDateToLocalDate2(utcTimestamp);
  }
}
